// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"63e2a8af","356":"308138af","535":"27c380d5","573":"e7eea1d5","710":"baaa4562","738":"1b684d13","795":"89aa1ac3"}[chunkId] + ".chunk.js";
};